import React from 'react'
import PageSection from '../../components/PageSection'
import { useTranslation } from '@sailor/i18n-web'
import { picUrl } from '@/common/utils/consts'
import QuestionDescription from '@/components/Questions'

const Questions: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div >
      <PageSection title={t('ent_o_hero_title')} subtitle={t('ent_o_hero_subtitle')}  backgroundImage={picUrl.questionTitleHeader}/>
      <QuestionDescription/>
    </div>
  )
}

export default Questions